import useTravelModeContext from '@contexts/travelModeContext'
import { colors, size, fontSize } from '@styles/theme'
import { useAuthContext } from '@contexts/authContext'
import styled from '@emotion/styled'
import { PiPaperPlaneRightBold, PiArrowLeftBold } from 'react-icons/pi'
import NavTextField from '@elements/NavTextField'

const TravelModeButton = styled(NavTextField)`
  height: ${size(3.5)};
`

const TravelButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: grey;
  font-size: ${fontSize('sm')};
  white-space: nowrap;
`

const TravelModeSelectorButton = ({ containerProps, contentProps, iconProps }) => {
  const { state: authState } = useAuthContext()
  const {
    isTravelModeSelectorEnabled,
    turnOffTravelModeSelector,
    turnOnTravelModeSelector,
  } = useTravelModeContext()

  const renderSelectorScreenButton = () => (
    <TravelModeButton
      style={{ backgroundColor: 'grey' }}
      onClick={turnOffTravelModeSelector}
      {...containerProps}>
      <TravelButtonContent
        style={{ color: 'white' }}
        {...contentProps}>
        <PiArrowLeftBold
          fill='white'
          size={size(1.75)}
          {...iconProps}
        />
        &nbsp;&nbsp;Exit Travel Mode
      </TravelButtonContent>
    </TravelModeButton>
  )

  const renderTravelModeEnabledButton = () => (
    <TravelModeButton
      style={{ backgroundColor: colors.statusColors.right_now('primary') }}
      onClick={turnOnTravelModeSelector}
      {...containerProps}>
      <TravelButtonContent
        style={{ color: 'white' }}
        {...contentProps}>
        <PiPaperPlaneRightBold
          fill='white'
          size={size(1.6)}
          {...iconProps}
        />
        &nbsp;&nbsp;Traveling Now
      </TravelButtonContent>
    </TravelModeButton>    
  )

  const renderDefaultButton = () => (
    <TravelModeButton
      onClick={turnOnTravelModeSelector}
      {...containerProps}>
      <TravelButtonContent {...contentProps}>
        <PiPaperPlaneRightBold
          fill='grey'
          size={size(1.6)}
          {...iconProps}
        />
        &nbsp;&nbsp;Enter Travel Mode
      </TravelButtonContent>
    </TravelModeButton>
  )

  const renderButton = () => {
    if (isTravelModeSelectorEnabled) {
      return renderSelectorScreenButton()
    } else if (authState?.user?.travelModeEnabledAt) {
      return renderTravelModeEnabledButton()
    } else {
      return renderDefaultButton()
    }
  }

  return renderButton()
}

export default TravelModeSelectorButton
